import moment from "moment-timezone";
import React from "react";

const DateColumn = ({ dateTime }: any) => {
  const dateObj = dateTime && moment(dateTime).tz(moment.tz.guess());
  return (
    <div>
      {dateObj ? (
        <div className="__container">
          <div>
            <b>{dateObj.format("MM/D/YY")}</b>
          </div>
          <div className="time">{dateObj.format("h:mma")}</div>
          <style>{`
                .__container {
            display: flex;
            flex-direction: column;
            min-width: 100px;
          }
          .time {
            font-weight: 300;
          }
        `}</style>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default DateColumn;
